<template>
  <!-- 数字滚动展示容器 -->
  <h4 class="number-counter" ref="counterRef">
    {{ formattedNumber }}
  </h4>
</template>

<script setup>
import { ref, computed, onMounted, watch, defineProps } from "vue";

// 接收外部参数
const props = defineProps({
  // 目标数值
  target: {
    type: Number,
    required: true,
    default: 0,
  },
  // 动画总时长(毫秒)
  duration: {
    type: Number,
    default: 2000,
  },
  // 是否显示千分位
  showThousandSeparator: {
    type: Boolean,
    default: true,
  },
});

// 引用DOM元素
const counterRef = ref(null);
// 当前数值
const currentNumber = ref(0);
// 格式化后的数字（计算属性）
const formattedNumber = computed(() => {
  if (props.showThousandSeparator) {
    // 千分位格式化
    return Math.floor(currentNumber.value).toLocaleString("en-US");
  }
  return Math.floor(currentNumber.value).toString();
});

// 动画核心函数
function startCountAnimation() {
  // 重置当前值
  currentNumber.value = 0;
  // 计算帧率（基于屏幕刷新率，约60帧/秒）
  const frameRate = 60;
  const totalFrames = Math.floor(props.duration / (1000 / frameRate));
  const increment = props.target / totalFrames;

  let frameIndex = 0;

  // 逐帧更新
  function updateFrame() {
    frameIndex++;
    currentNumber.value += increment;
    // console.log(
    //   frameIndex,
    //   totalFrames,
    //   increment,
    //   props.duration,
    //   1000 / frameRate,
    // );
    // 达到目标值则停止
    if (frameIndex >= totalFrames || currentNumber.value >= props.target) {
      currentNumber.value = props.target;
      return;
    }

    // 继续下一帧
    requestAnimationFrame(updateFrame);
  }

  // 启动动画
  requestAnimationFrame(updateFrame);
}

// 监听元素进入视口后启动动画（优化体验）
function setupIntersectionObserver() {
  if (!counterRef.value) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          startCountAnimation();
          // 只执行一次
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }, // 元素50%进入视口触发
  );

  observer.observe(counterRef.value);
}

// 组件挂载后初始化
onMounted(() => {
  setupIntersectionObserver();
});

// 监听目标值变化，重新启动动画（可选）
watch(
  () => props.target,
  () => {
    if (counterRef.value) {
      setupIntersectionObserver();
    }
  },
  { immediate: false },
);
</script>

<style scoped>
.number-counter {
  /* font-size: 70px; */
  /* font-weight: bold; */
  /* color: #333; */
  /* 可选：添加过渡让数字变化更顺滑 */
  transition: all 0.05s ease;
}
</style>
